import MyComponentView from './HomeView';

const Edit = (props) => {
  return <div>this component is not editable</div>;
};

export default Edit;
